// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.105.4_postcss@8.5.8_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.105.4_postcss@8.5.8_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-loader-hatch-status-icon > svg {
  width: 36px;
  height: 36px;
}
.file-loader-hatch-status-icon.loaded-icon > svg {
  color: green;
}
.file-loader-hatch-status-icon.validated-icon > svg {
  color: goldenrod;
}
.file-loader-hatch-status-icon.failed-icon > svg {
  color: firebrick;
}
.file-loader-hatch-status-icon.unknown-icon > svg {
  color: purple;
}
.ant-upload-drag-container,
.nkl-upload-drag-container {
  padding: 24px;
}
.file-loader-hatch-upload-icon > svg {
  width: 48px;
  height: 48px;
}
.file-loader-hatch-file-icon {
  margin-right: 6px;
  overflow: visible;
  height: 14px;
  position: relative;
  top: 1px;
  color: firebrick;
}
.file-loader-hatch-file-icon > svg {
  width: 16px;
  height: 16px;
}
.file-loader-hatch-errors.ant-tooltip {
  max-width: unset;
}
.file-loader-hatch-errors ul {
  padding: 0 0 0 6px;
  margin: 0 0 0 12px;
}
.file-loader-hatch-error-list ul > li {
  margin: 0 0 6px 0;
}
.file-loader-supported-types {
  text-align: center;
  color: gray;
  margin-top: 16px;
}
.file-loader-file-table .ant-table-wrapper .ant-table-thead > tr > th,
.file-loader-file-record-table .ant-table-wrapper .ant-table-thead > tr > th {
  font-weight: 500;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
